<template>
    <div
        :aria-expanded="active"
        :aria-label="label"
        aria-haspopup="listbox"
        class="input-container"
        role="combobox"
        tabindex="0"
        @click="toggleActive"
        @keydown.enter="toggleActive"
        @keydown.space.prevent="toggleActive"
        @keydown.down.prevent="navigateDown"
        @keydown.up.prevent="navigateUp"
        @keydown.esc="active = false"
    >
        <img :src="icon" alt="" aria-hidden="true" class="icon" />
        <p v-if="selectedItem" id="liste-deroulante" class="texte-trop-long">{{ display(selectedItem) }}</p>
        <span :class="(active || selectedItem) && 'label-active'" aria-hidden="true" class="label">{{ label }}</span>
        <span v-if="labelVide && list.length === 0" aria-hidden="true">
            {{ labelVide }}
        </span>
        <div v-if="active" :style="{ width: width }" class="drop-container" role="listbox">
            <div
                v-for="(item, index) in list"
                :key="index"
                :aria-selected="selectedItem === item"
                :class="{ 'item-focused': focusedIndex === index }"
                class="item-display"
                role="option"
                tabindex="-1"
                @click.stop="select(item)"
                @keydown.enter.stop="select(item)"
                @keydown.space.prevent.stop="select(item)"
            >
                <span class="width-93pct texte-trop-long">
                    {{ display(item) }}
                </span>
                <img v-if="item.favori" :src="loadIconFavori" alt="" class="right width-5pct" />
            </div>
            <div v-if="labelCreation" class="bar-horizontale"></div>
            <div
                v-if="labelCreation"
                class="item-display texte-bleu"
                role="button"
                tabindex="0"
                @click.stop="modeCreation"
                @keydown.enter.stop="modeCreation"
            >
                <span>
                    {{ labelCreation }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    data() {
        return {
            active: false,
            focusedIndex: -1,
        };
    },
    props: {
        list: { type: Array, required: true },
        selectedItem: {
            type: [String, Object],
        },
        display: { type: Function, required: true },
        label: { type: String, required: true },
        labelCreation: { type: String, required: false },
        labelVide: { type: String, required: false },
        width: { type: String, required: false },
    },
    methods: {
        toggleActive() {
            this.active = !this.active;
            if (this.active) {
                this.focusedIndex = this.list.indexOf(this.selectedItem);
            }
        },
        navigateDown() {
            if (!this.active) {
                this.active = true;
                this.focusedIndex = 0;
                return;
            }
            if (this.focusedIndex < this.list.length - 1) {
                this.focusedIndex++;
            }
        },
        navigateUp() {
            if (this.focusedIndex > 0) {
                this.focusedIndex--;
            }
        },
        select(value) {
            this.active = false;
            this.focusedIndex = -1;
            this.$emit('select', value);
        },
        close(e) {
            if (!this.$el.contains(e.target)) {
                this.active = false;
            }
        },
        modeCreation() {
            this.active = false;
            this.$emit('creation');
        },
    },
    computed: {
        icon() {
            return require('@/assets/img/menu-down.svg');
        },
        loadIconFavori() {
            return require('@/assets/img/icons/favoriVioletRempli.png');
        },
    },
    mounted() {
        document.addEventListener('click', this.close);
    },
});
</script>

<style scoped>
.input-container {
    box-sizing: border-box;
    font-family: 'Roboto';
    height: 50px;
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-direction: row-reverse;
    border: 1px solid var(--medium-dark-grey);
    border-radius: 4px;
    padding: 11px 12px;
    align-items: center;
    font-weight: 400;
    font-size: var(--font-size-low-medium);
}
.label {
    font-family: 'Roboto';
    position: absolute;
    pointer-events: none;
    left: 12px;
    top: calc(50% - var(--font-size-low-medium) / 2);
    transition: 0.2s ease all;
    padding: 2px;
    background-color: var(--white);
    color: var(--medium-dark-grey);
    font-size: var(--font-size-low-medium);
}
.label-active {
    top: -7px;
    font-size: var(--font-size-very-small);
}
.item-display:hover,
.item-focused {
    background-color: #f5f5f5;
}
.item-display {
    padding: 14px 24px;
    cursor: pointer;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.drop-container {
    max-height: 250px;
    overflow-y: auto;
    z-index: 1000;
    width: 100%;
    background-color: var(--white);
    position: absolute;
    top: 39px;
    left: 0;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 1px 5px rgba(0, 0, 0, 0.12);
}
.icon {
    margin: 0;
    height: 24px;
}
.bar-horizontale {
    border-bottom: 1px solid #ccc;
    margin-right: 10px;
    margin-left: 10px;
}
.texte-bleu {
    color: var(--bleu-clair);
}
.texte-trop-long {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
</style>
